import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ParticipantsSearchWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};
  .form-header {
    padding-left: 16px;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
    .form-header-right {
      text-align: right;
      .MuiButton-root {
        height: auto;
        padding-left: 4px;

        svg {
          margin-right: 10px;
        }
      }
    }
  }
  .form-container {
    padding: 0px 0px 16px 16px;

    ${responsive.MOBILE`
      padding: 0;
    `}
    .first-row {
      padding-top: 24px;
    }
  }
  .form-field {
    margin-top: 40px;
    ${responsive.MOBILE`
      margin-top:24px;
    `}
  }
  .button-container {
    justify-content: end;
    padding-bottom: 20px;
    gap: 16px;
    margin-right: 16px;
    margin-top: 40px;

    ${responsive.MOBILE`
      flex-direction: column-reverse;
      margin-top: 16px;
      margin-right: 8px;
      padding-bottom: 0;
    `}
    button {
      ${responsive.MOBILE`
        width:100%;
        margin: 0;
      `}
    }
  }
  .padding-horizontal {
    ${responsive.MOBILE`
      margin: 0px 8px;
    `}
  }
  .MuiGrid2-root {
    padding-right: 16px;

    ${responsive.MOBILE`
     padding-right: 8px;
    `}
  }
  .MuiGrid2-container {
    padding-right: 0px;
  }

  .reset-all-button {
    margin-right: 16px;
  }
`;
